(function (scope) {
	'use strict';

	var AnchorAnimate = function (elementsOrSelector) {
		
		if (typeof elementsOrSelector === 'string') {
			this.$elements = $(elementsOrSelector);
		} else if (elementsOrSelector !== undefined) {
			this.$elements = elementsOrSelector;
		}
		
		if (this.$elements.length) {
			this.initialize();
		} else {
			console.warn('AnchorAnimate selector doesn\'t match any elements.');
		}
	};

	AnchorAnimate.prototype.initialize = function () {
		this.addEventHandlers();
	};

	AnchorAnimate.prototype.addEventHandlers = function () {
		this.handleClick = this.onClick.bind(this);
		this.$elements.on('click touchdown', this.handleClick);
	};

	AnchorAnimate.prototype.onClick = function (event) {
		var href = $(event.target).attr('href');

		if (href && href.length && href.charAt(0) === '#') {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $(href).offset().top
			}, 500);
		}
	};

	scope.AnchorAnimate = AnchorAnimate;
})(window.Roots || (window.Roots = {}));
